export default {
  public: {
    loading: "加载中...",
    ok: "确认",
    cancel: "取消",
    back: "返回",
    userDefined: "自定义",
    edit: "编辑",
    clear: "清空",
    delete: "删除",
    close: "关闭",
    remove: "移除",
    preView: "预览",
    replace: "替换",
    systemMsg: "系统提示",
    generateSuccess: "您的 PowerPoint 演示文稿已成功生成！",
    templateChoose: "选择一个模板来进行您自己的AI创作",
    templateChooseShort: "选择一个模板",
    templateChangeTips:
      "替换模板数据会将其恢复为原始内容。修改的内容将会丢失。你确定你要继续吗？",
    sourceInvalid: "数据来源不合法，请重试。",
    systemBusy: "系统繁忙，请刷新页面",
    templateReplaceSuccess: "模板更换成功。请手动保存，系统不会自动保存。",
    shareLinkTips: "复制成功！正在为您跳转",
    copyTips: "复制成功！",
    loginTips: "请先登录！",
    fontType: {
      Arial: "Arial",
      "Microsoft Yahei": "微软雅黑",
      SimSun: "宋体",
      SimHei: "黑体",
      KaiTi: "楷体",
      NSimSun: "新宋体",
      FangSong: "仿宋",
      "PingFang SC": "苹方",
      STHeiti: "华文黑体",
      STKaiti: "华文楷体",
      STSong: "华文宋体",
      STFangSong: "华文仿宋",
      STZhongSong: "华文中宋",
      STHupo: "华文琥珀",
      STXinwei: "华文新魏",
      STLiti: "华文隶书",
      STXingkai: "华文行楷",
      "Hiragino Sans GB": "冬青黑体",
      "Lantinghei SC": "兰亭黑",
      "Hanzipen SC": "偏偏体",
      "Hannotate SC": "手札体",
      "Songti SC": "宋体",
      "Wawati SC": "娃娃体",
      "Xingkai SC": "行楷",
      "Yuanti SC": "圆体",
      STXihei: "华文细黑",
      YouYuan: "幼圆",
      LiSu: "隶书",
    },
    font: {
      font: "字体",
      sysFont: "系统字体",
      lineFont: "在线字体",
      fontColor: "文字颜色",
      textColor: "字体颜色",
      fontDelay: "文字高亮",
      addSize: "增大字号",
      duceSize: "减小字号",
      left: "左对齐",
      middle: "居中",
      horizontalCenter: "水平居中",
      verticalCenter: "垂直居中",
      right: "右对齐",
      bottom: "底对齐",
      top: "顶对齐",
      bold: "加粗",
      em: "斜体",
      underline: "下划线",
      strikethrough: "删除线",
      richText: "清除格式",
      textFormat: "格式刷",
      addIndex: "增大缩进",
      duceIndex: "减小缩进",
      no: "编号",
      link: "超链接",
      inputLink: "请输入超链接",
      superscript: "上标",
      subscript: "下标",
      code: "行内代码",
      blockquote: "引用",
      horizontal: "水平",
      vertical: "垂直",
      width: "宽度",
      height: "高度",
      rotate: "旋转",
      uniformHorizontal: "水平均匀分布",
      uniformVertical: "垂直均匀分布",
      combine: "组合",
      unCombine: "取消组合",
      bgColor: "背景颜色",
      mainColor: "主题色",
      useMainToAll: "应用主题到全部",
      preMain: "预置主题",
    },
    specialEffects: {
      useAll: "应用到全部",
      no: "无",
      fade: "淡入淡出",
      slideX: "左右推移",
      slideY: "上下推移",
    },
  },
  extension: {
    nonsupportDownloadPDF:
      "浏览器插件暂不支持下载PDF, 请去官网下载",
  },
  index: {
    createText: "正在生成PPT文案",
    createPage: "正在生成PPT第{0}页内容",
    haveProblem: "我遇到问题了",
    systemError: "系统异常提示: {0}",
    saveText: "保存成功",
    saveMessage: "确定保存吗?",
    cBtn: "取消",
    sBtn: "确定",
    waitMsg: "请耐心等待30~40秒，如果未生成请刷新浏览器重试！",
  },
  errorCode: {
    401: "认证失败，无法访问系统资源",
    403: "当前操作没有权限",
    404: "访问资源不存在",
    default: "系统未知错误，请反馈给管理员",
    notReDo: "数据正在处理，请勿重复提交",
    loginMsg: "无效的会话，或者会话已过期，请重新登录。",
    errMsg: "系统繁忙请稍后重试",
  },
  linkHandler: {
    pptPage: "幻灯片页面",
    change: "更换",
    remove: "移除",
  },
  editor: {
    ctrlV: "粘贴",
    ctrlA: "全选",
    enter: "新建页面",
    f5: "幻灯片放映",
    delete: "删除页面",
    ctrlD: "复制页面",
    ctrlX: "剪切",
    ctrlC: "复制",
    shiftF5: "从当前放映",
    canvas: {
      index: {
        ctrlR: "标尺",
        ctrlW: "网格线",
        nl: "无",
        small: "小",
        middle: "中",
        big: "大",
        closePan: "关闭选择面板",
        openPan: "打开选择面板",
        reCurrentPage: "重置当前页",
        showPpt: "幻灯片放映",
      },
      linkDialog: {
        url: "请输入网页链接地址",
        ppt: "幻灯片",
        preView: "预览",
        pageUrl: "网页链接",
        pptPage: "幻灯片页面",
      },
    },
    canvasTool: {
      index: {
        ctrlZ: "撤销",
        reSet: "重做",
        text: "插入文字",
        horizontal: "横向文本框",
        vertical: "竖向文本框",
        image: "插入图片",
        shape: "插入形状",
        line: "插入线条",
        chart: "插入图表",
        table: "插入表格",
        gs: "插入公式",
        voice: "插入音视频",
        screen: "适应屏幕",
        workspase: "工作台",
        save: "保存",
        logo: "插入Logo",
        close: "关闭PPT",
        download: "下载",
        share: "分享",
        templateReplacement: "替换模板",
      },
      mediaInput: {
        videoUrl: "请输入视频地址，如：https://xxx.mp4",
        voiceUrl: "请输入音频地址，如：https://xxx.mp3",
        video: "视频",
        voice: "音频",
        videoError: "请先输入正确的视频地址",
        voiceError: "请先输入正确的音频地址",
      },
      tableGenerator: {
        table: "表格",
        row: "行数",
        column: "列数",
        rcError: "行数/列数必须在0~20之间！",
      },
      logo: {
        text1: "请上传公司Logo",
        text2: "请输入公司名称",
        companyNamePlaceholder: "输入你的公司名称",
        single: "单页面应用",
        all: "全部页面应用",
        position: "位置",
      },
    },
    editorHeader: {
      index: {
        file: "文件",
        importPptistFile: "导入 pptist 文件",
        importPptxFile: "导入 pptx 文件",
        exportPptxFile: "导出文件",
        undo: "撤销",
        redo: "重做",
        createSlide: "添加页面",
        deleteSlide: "删除页面",
        closeGridLines: "关闭网格线",
        openGridLines: "打开网格线",
        closeRuler: "关闭标尺",
        openRuler: "打开标尺",
        resetSlides: "重置幻灯片",
        closeSelectPanel: "关闭选择面板",
        openSelectPanel: "打开选择面板",
        f5: "演示",
        enterScreeningFromStart: "从头开始",
        enterScreening: "从当前页开始",
        help: "帮助",
        hotkey: "快捷键",
        pptShow: "幻灯片放映",
        export: "导出",
        importing: "正在导入...",
        continue: "继续生成",
        pauseGeneration: "暂停生成",
        noPricing: "成为我们的会员享有下载权限",
        noPricingToLook: "成为我们的会员享有查看权限",
        getTokens: "获取tokens",
        pptSlidesMsg: "恭喜你生成的{0}张完整的ppt ",
        Feedback: "回馈来到这个页面的用户",
        giveAway: "赠送优惠券（30分钟内有效）",
        getItNow: "立即获取",
        unlockAllPpt: "马上获取PPT全部权限",
        grantPermission: "赠送思维导图权益",
        grantPermissionToUseGpt: "赠送GPT权益",
        permissionCodeUse: "请记住优惠码，前往支付网页使用！",
        pptTi1:
          "You have completed all the work and generated a total of {0} pages of ppt. ",
        pptTi2:
          "You only need the last step to get your wonderful AI creation!",
      },
    },
    exportDialog: {
      exportScope: "导出范围",
      close: "关闭",
      all: "全部",
      thisPage: "当前页",
      auto: "自定义",
      autoScope: "自定义范围",
      exporting: "正在导出...",
      exportImg: "导出图片",
      expPdf: "打印 / 导出 PDF",
      expPptx: "导出 PPTX",
      exportImage: {
        exportType: "导出格式",
        imageQuality: "图片质量",
        ignoreFont: "忽略在线字体",
        ignoreLineFont:
          "导出时默认忽略在线字体，若您在幻灯片中使用了在线字体，且希望导出后保留相关样式，可选择关闭【忽略在线字体】选项，但要注意这将会增加导出用时。",
      },
      exportPdf: {
        all: "全部幻灯片",
        thisPage: "当前幻灯片",
        pageNum: "每页数量",
        white: "边缘留白",
        notice:
          "注意：若打印预览与实际样式不一致，请在弹出的打印窗口中勾选【背景图形】选项。",
      },
      exportPPTX: {
        title: "覆盖默认母版",
        notice: "注意：下载后请用Microsoft Office打开，因为其它可能不兼容。",
      },
    },
    remark: {
      remark: "点击输入演讲者备注",
    },
    thumbnails: {
      add: "添加幻灯片",
      slide: "幻灯片",
    },
    toolbar: {
      common: {
        elementColorMask: {
          recolor: "重新着色（蒙版）",
          maskColor: "蒙版颜色",
          opacity: "不透明度",
        },
        elementFilter: {
          enableFilter: "启用滤镜",
          blur: "模糊",
          brightness: "亮度",
          contrast: "对比度",
          grayscale: "灰度",
          saturate: "饱和度",
          hueRotate: "色相",
          opacity: "不透明度",
        },
        elementFlip: {
          horizontal: "水平翻转",
          vertical: "垂直翻转",
        },
        elementOpacity: {
          opacity: "不透明度",
        },
        elementOutline: {
          border: "启用边框",
          borderStyle: "边框样式",
          solid: "实线边框",
          dashes: "虚线边框",
          borderColor: "边框颜色",
          borderWeight: "边框粗细",
        },
        elementShadow: {
          enable: "启用阴影",
          horizontal: "水平阴影",
          vertical: "垂直阴影",
          fuzzyDistance: "模糊距离",
          color: "阴影颜色",
        },
      },
      panel: {
        background: "背景填充",
        solid: "纯色填充",
        image: "图片填充",
        gradient: "渐变填充",
        contain: "缩放",
        repeat: "拼贴",
        cover: "缩放铺满",
        linear: "线性渐变",
        radial: "径向渐变",
        startColor: "起点颜色",
        endColor: "终点颜色",
        rotate: "渐变角度",
        useBackgroundToAll: "应用背景到全部",
      },
      elementStylePanel: {
        chartStylePanel: {
          chartDataEditor: {
            rowType: "类别",
            colType: "系列",
          },
          index: {
            edit: "编辑图表数据",
            area: "面积图样式",
            line: "散点图样式",
            lineSmooth: "使用平滑曲线",
            horizontalBars: "条形图样式",
            stackBars: "堆叠样式",
            donut: "环形图样式",
            img: "图例",
            hidden: "不显示",
            showTop: "显示在上方",
            showBottom: "显示在下方",
            tabColor: "网格颜色",
            titleSetColor: "主题配色：",
            title: "推荐主题",
            titleColor: "添加主题色",
          },
        },
        audioStylePanel: {
          imgColor: "图标颜色",
          autoPlay: "自动播放",
          loopPlay: "循环播放",
        },
        imageStylePanel: {
          cutImg: "裁剪图片",
          shape: "按形状",
          type: "分类",
          preview: "预 览",
          use: "使 用",
          searchByType: "按分类寻图",
          uploadAndReplace: "上传图片并替换",
          reSetStyle: "重置样式",
          setBackground: "设为背景",
          clip1: "按纵横比（方形）",
          clip2: "按纵横比（纵向）",
          clip3: "按纵横比（横向）",
        },
        latexStylePanel: {
          edit: "编辑 LaTeX",
          color: "颜色",
          bold: "粗细",
        },
        lineStylePanel: {
          style: "线条样式",
          solid: "实线",
          dotted: "虚线",
          color: "线条颜色",
          weight: "线条宽度",
          startStyle: "起点样式",
          endStyle: "终点样式",
          none: "无",
          arrow: "箭头",
          dot: "圆点",
        },
        multiStylePanel: {
          colorPicker: "填充颜色",
          style: "边框样式",
          solid: "实线边框",
          dotted: "虚线边框",
          color: "边框颜色",
          weight: "边框粗细",
        },
        shapeStylePanel: {
          replaceShade: "点击替换形状",
          fill: "纯色填充",
          gradient: "渐变填充",
          linear: "线性渐变",
          radial: "径向渐变",
        },
        tableStylePanel: {
          colFull: "单元格填充",
          row: "行数",
          col: "列数",
          titleRow: "标题行",
          totalRow: "汇总行",
          firstCol: "第一列",
          lastCol: "最后一列",
          titleColor: "主题颜色",
          themeTable: "主题表格",
        },
        textStylePanel: {
          urlError: "不是正确的网页链接地址",
          command: "项目符号",
          lineHeight: "行间距",
          times: "倍",
          paragraphSpace: "段间距",
          wordSpace: "字间距",
          textIndent: "首行缩进",
          textFill: "文本框填充",
          title: "大标题",
          titleSmall: "小标题",
          text: "正文",
          textSmall: "正文[小]",
          zs1: "注释 1",
          zs2: "注释 2",
        },
        videoStylePanel: {
          cover: "视频预览封面",
          recover: "重置封面",
        },
      },
      elementAnimationPanel: {
        addEffects: "添加动画",
        selectAndAddEffects: "选中画布中的元素添加动画",
        time: "持续时长",
        triggerType: "触发方式",
        initiative: "主动触发",
        sameTime: "与上一动画同时",
        after: "上一动画之后",
        change: "更换动画",
        in: "入场",
        out: "退场",
        attention: "强调",
      },
      elementPositionPanel: {
        layer: "层级",
        align: "对齐",
        top: "置顶",
        bottom: "置底",
        up: "上移",
        down: "下移",
        noRixedRatio: "解除宽高比锁定",
        fixedRatio: "宽高比锁定",
      },
      index: {
        style: "样式",
        symbol: "符号",
        position: "位置",
        animation: "动画",
        design: "设计",
        slideAnimation: "切换",
      },
      slideDesignPanel: {
        canvasSize: "画布尺寸",
        wideScreen1: "宽屏 16 : 9",
        wideScreen2: "宽屏 16 : 10",
        standard: "标准 4 : 3",
        paper: "纸张 A3 / A4",
        title: "全局主题",
        mainColor: "主题色",
        useMainToAll: "应用主题到全部",
        preMain: "预置主题",
        text: "文字 Aa",
        use: "应用",
        useToAll: "应用全部",
      },
    },
    selectPanel: {
      select: "选择",
      showAll: "全部显示",
      hideAll: "全部隐藏",
      group: "组合",
    },
    redraw: {
      topLabel: "重新生成",
      msgTips: "请输入生成的内容",
      retext: "重新生成",
      cltext: "撤销",
      btnText: "生成",
      reConfirm: "生成后将替换本页并不会保存历史内容，确认要继续吗？",
      confirmBtnTxt: "继续",
    },
  },
  screen: {
    presenter: {
      normalView: "普通视图",
      pen: "画笔",
      laserPointer: "激光笔",
      timer: "计时器",
      exitFullScreen: "退出全屏",
      fullScreen: "全屏",
      endPresentation: "结束放映",
      speakerNotes: "演讲者备注",
      speakersView: "演讲者视图",
      previousPage: "上一页",
      nextPage: "下一页",
      firstPage: "第一页",
      lastPage: "最后一页",
      brushTool: "画笔工具",
      noRemarks: "无备注",
    },
    writingBoard: {
      inkThickness: "墨迹粗细",
      eraserSize: "橡皮大小",
      eraser: "橡皮擦",
      clearInk: "清除墨迹",
      blackboard: "黑板",
      closeBrush: "关闭画笔",
    },
  },
  mobile: {
    index: {
      notSupport: "手机版正在加急开发中",
      toPc: "请前往PC打开网址",
      editTips: "请到PC端编辑",
    },
  },
  useCreateElement: {
    type: "类别{0}",
    class: "系列{0}",
  },
  components: {
    latexEditor: {
      index: {
        lateX: "输入 LaTeX 公式",
        preViw: "公式预览",
        symbol: "常用符号",
        formula: "预置公式",
        error: "公式不能为空",
      },
    },
    colorPicker: {
      recentUse: "最近使用",
    },
  },
  config: {
    latex: {
      gauss: "高斯公式",
      fourierSeries: "傅里叶级数",
      taylorExpansion: "泰勒展开式",
      definiteIntegral: "定积分",
      trigonometricIdentity1: "三角恒等式1",
      trigonometricIdentity2: "三角恒等式2",
      expansion: "和的展开式",
      euler: "欧拉公式",
      differential: "贝努利方程",
      totalDifferentialEquation: "全微分方程",
      homogeneous: "非齐次方程",
      cauchy: "柯西中值定理",
      lagrange: "拉格朗日中值定理",
      arcsin: "导数公式",
      trigonometric: "三角函数积分",
      quadric: "二次曲面",
      dx: "二阶微分",
      partial: "方向导数",
      operators: "数学",
      group: "组合",
      verbatim: "函数",
      greek: "希腊字母",
    },
    symbol: {
      letter: "字母",
      number: "序号",
      math: "数学",
      arrow: "箭头",
      graph: "图形",
    },
    lines: {
      straight: "直线",
      brokenOrCurve: "折线、曲线",
    },
  },
  hotkey: {
    opt: {
      common: "通用",
      ctrlX: "剪切",
      ctrlC: "复制",
      ctrlV: "粘贴",
      ctrlD: "快速复制粘贴",
      ctrlA: "全选",
      ctrlZ: "撤销",
      ctrlY: "恢复",
      del: "删除",
      ctrlMore: "多选",
      ctrlP: "打印",
      esc: "关闭弹窗",
    },
    slide: {
      show: "幻灯片放映",
      edit: "幻灯片编辑",
      first: "从头开始放映幻灯片",
      current: "从当前开始放映幻灯片",
      spacePre: "切换上一页",
      spaceNext1: "切换下一页",
      spaceNext2: "切换下一页",
      out: "退出放映",
      new: "新建幻灯片",
      move: "移动画布",
      upOrDown: "缩放画布",
      up: "放大画布",
      down: "缩小画布",
      screen: "使画布适应当前屏幕",
      noSelectPrePage: "上一页（未选中元素）",
      noSelectNextPage: "下一页（未选中元素）",
      prePage: "上一页",
      nextPage: "下一页",
    },
    element: {
      opt: "元素操作",
      move: "移动",
      lock: "锁定",
      combo: "组合",
      cancelCombo: "取消组合",
      top: "置顶层",
      bottom: "置底层",
      h: "锁定宽高比例",
      v: "创建水平 / 垂直线条",
      change: "切换焦点元素",
      com: "确认图片裁剪",
      text: "文本",
      image: "图片",
      shape: "形状",
      line: "线条",
      chart: "图表",
      table: "表格",
      video: "视频",
      audio: "音频",
      latex: "公式",
    },
    table: {
      edit: "表格编辑",
      nextCol: "聚焦到下一个单元格",
      insertTop: "在上方插入一行",
      insertBottom: "在下方插入一行",
      insertLeft: "在左侧插入一列",
      insertRight: "在右侧插入一列",
    },
    chat: {
      edit: "图表数据编辑",
      nextLine: "聚焦到下一行",
    },
    text: {
      edit: "文本编辑",
      bold: "加粗",
      italics: "斜体",
      underline: "下划线",
      delLine: "删除线",
    },
  },
  shape: {
    rectangle: "矩形",
    commonUse: "常用形状",
    arrow: "箭头",
    other: "其他形状",
    line: "线性",
  },
  animation: {
    in: {
      bounce: "弹跳",
      bounceIn: "弹入",
      bounceInLeft: "向右弹入",
      bounceInRight: "向左弹入",
      bounceInUp: "向上弹入",
      bounceInDown: "向下弹入",
      fade: "浮现",
      fadeIn: "浮入",
      fadeInDown: "向下浮入",
      fadeInDownBig: "向下长距浮入",
      fadeInLeft: "向右浮入",
      fadeInLeftBig: "向右长距浮入",
      fadeInRight: "向左浮入",
      fadeInRightBig: "向左长距浮入",
      fadeInUp: "向上浮入",
      fadeInUpBig: "向上长距浮入",
      fadeInTopLeft: "从左上浮入",
      fadeInTopRight: "从右上浮入",
      fadeInBottomLeft: "从左下浮入",
      fadeInBottomRight: "从右下浮入",
      rotate: "旋转",
      rotateIn: "旋转进入",
      rotateInDownLeft: "绕左下进入",
      rotateInDownRight: "绕右下进入",
      rotateInUpLeft: "绕左上进入",
      rotateInUpRight: "绕右上进入",
      zoom: "缩放",
      zoomIn: "放大进入",
      zoomInDown: "向下放大进入",
      zoomInLeft: "从左放大进入",
      zoomInRight: "从右放大进入",
      zoomInUp: "向上放大进入",
      slide: "滑入",
      slideInDown: "向下滑入",
      slideInLeft: "从右滑入",
      slideInRight: "从左滑入",
      slideInUp: "向上滑入",
      flip: "翻转",
      flipInX: "X轴翻转进入",
      flipInY: "Y轴翻转进入",
      back: "放大滑入",
      backInDown: "向下放大滑入",
      backInLeft: "从左放大滑入",
      backInRight: "从右放大滑入",
      backInUp: "向上放大滑入",
      lightSpeed: "飞入",
      lightSpeedInRight: "从右飞入",
      lightSpeedInLeft: "从左飞入",
    },
    out: {
      bounce: "弹跳",
      bounceOut: "弹出",
      bounceOutLeft: "向左弹出",
      bounceOutRight: "向右弹出",
      bounceOutUp: "向上弹出",
      bounceOutDown: "向下弹出",
      fade: "浮现",
      fadeOut: "浮出",
      fadeOutDown: "向下浮出",
      fadeOutDownBig: "向下长距浮出",
      fadeOutLeft: "向左浮出",
      fadeOutLeftBig: "向左长距浮出",
      fadeOutRight: "向右浮出",
      fadeOutRightBig: "向右长距浮出",
      fadeOutUp: "向上浮出",
      fadeOutUpBig: "向上长距浮出",
      fadeOutTopLeft: "从左上浮出",
      fadeOutTopRight: "从右上浮出",
      fadeOutBottomLeft: "从左下浮出",
      fadeOutBottomRight: "从右下浮出",
      rotate: "旋转",
      rotateOut: "旋转退出",
      rotateOutDownLeft: "绕左下退出",
      rotateOutDownRight: "绕右下退出",
      rotateOutUpLeft: "绕左上退出",
      rotateOutUpRight: "绕右上退出",
      zoom: "缩放",
      zoomOut: "缩小退出",
      zoomOutDown: "向下缩小退出",
      zoomOutLeft: "从左缩小退出",
      zoomOutRight: "从右缩小退出",
      zoomOutUp: "向上缩小退出",
      slide: "滑出",
      slideOutDown: "向下滑出",
      slideOutLeft: "从左滑出",
      slideOutRight: "从右滑出",
      slideOutUp: "向上滑出",
      flip: "翻转",
      flipOutX: "X轴翻转退出",
      flipOutY: "Y轴翻转退出",
      back: "缩小滑出",
      backOutDown: "向下缩小滑出",
      backOutLeft: "从左缩小滑出",
      backOutRight: "从右缩小滑出",
      backOutUp: "向上缩小滑出",
      lightSpeed: "飞出",
      lightSpeedOutRight: "从右飞出",
      lightSpeedOutLeft: "从左飞出",
    },
    attention: {
      shake: "晃动",
      shakeX: "左右摇晃",
      shakeY: "上下摇晃",
      headShake: "摇头",
      swing: "摆动",
      wobble: "晃动",
      tada: "惊恐",
      jello: "果冻",
      other: "其他",
      bounce: "弹跳",
      flash: "闪烁",
      pulse: "脉搏",
      rubberBand: "橡皮筋",
      heartBeat: "心跳（快）",
    },
  },
  requestError: {
    tokenExpires: "认证失败，无法访问系统资源",
    permissionDenied: "当前操作没有权限",
    notFound: "访问资源不存在",
    default: "系统未知错误，请反馈给管理员",
    ExceptionReminder: "异常提醒",
    pleaseLogin: "无效的会话，或者会话已过期，请重新登录。",
    networkError: "后端接口连接异常",
    requestTimeOut: "系统接口请求超时",
    requestFailed: "系统接口异常，请稍后",
  },
  promptsText: {
    theme: [
      "探索不同的主题，发现无限乐趣！",
      "点击进入各个主题页，开启奇妙之旅！",
      "每个主题都有独特的魅力，不妨一一探索！",
      "欢迎来到主题世界，选择你感兴趣的主题开始探险！",
      "你的第一张AI幻灯片即将来临，敬请期待吧",
      "踏上幻灯片之旅，即将出发...",
      "准备好迎接新的视觉盛宴了吗？幻灯片即将启程...",
      "坐稳！下一站，奇幻幻灯片之旅...",
      "快！闭上眼睛，等待惊喜的幻灯片到来...",
      "幻灯片世界即将为您打开，敬请期待...",
      "请耐心等待，幻灯片之梦即将成真...",
    ],
    directory: [
      "在目录页上，找到你想要的一切！",
      "目录页是你的导航宝藏，让你轻松找到所需！",
      "目录页为你提供了全面的导航服务，让你快速找到目标！",
      "不知道去哪里？在目录页上找到灵感和方向！",
    ],
    Content: [
      "等待中...下一张幻灯片会像彩虹一样绚丽多彩！",
      "哇！下一张幻灯片将会像烟花一样绽放，让你惊叹不已！",
      "耐心等待，下一张幻灯片就像等待梦幻般的彩虹出现一样美好！",
      "感受等待的魔力！下一张幻灯片会让你眼前一亮！",
      "拭目以待！下一张幻灯片将给你带来一场视觉盛宴的惊喜！",
      "快！拉起窗帘，准备好迎接下一张幻灯片的耀眼光芒！",
      "请做好准备！下一张幻灯片将带来一阵清新的视觉风暴！",
      "你的好奇心即将得到满足！下一张幻灯片会给你惊喜！",
      "等待中...下一张幻灯片将给你带来一段美妙的视觉旅程！",
      "迫不及待了吗？下一张幻灯片会像一场盛大的庆典一样激动人心！",
      "猜猜下一张幻灯片会是什么？答案即将揭晓...",
      "请系好安全带，我们即将飞向下一张幻灯片...",
      "快乐马上来临！下一张幻灯片正在加速驶来...",
      "猜猜下一张幻灯片会是什么色彩？答案即将揭晓...",
      "哇！下一张幻灯片将带给您意想不到的惊喜...",
      "跃跃欲试？下一张幻灯片将满足您的好奇心...",
      "等待中...下一张幻灯片会给您带来欢乐与惊喜...",
      "等待中...就像等待一杯美味的咖啡，下一张幻灯片也会让你心情愉悦！",
      "闭上眼，数到三，下一张幻灯片将会带来惊喜！1... 2... 3...",
      "在冒险中！等待下一张幻灯片，就像等待发现宝藏一样刺激！",
      "准备好了吗？下一张幻灯片将会带来一场奇妙的冒险之旅！",
    ],
    Comprehensive: [
      "点点滴滴，探索不尽的趣味世界！",
      "从主题到目录，再到内容页，每一步都是发现的旅程！",
      "让我们一起踏上奇妙之旅，在这个精彩的世界中留下足迹！",
      "在这个充满惊喜的网站上，让我们一起去发现更多！",
    ],
    Unpurchased: [
      "跃跃欲试？下一张幻灯片即将掀起一场视觉盛宴，快来参与吧！",
      "不仅仅是商品，更是一种生活态度！点击购买，让心情放飞！",
      "在这里，你不只是买产品，更是买到了满满的幸福！",
      "加入会员，开启快乐人生新篇章！",
      "点击购买，让你的每一天都充满惊喜和乐趣！",
      "购买不止是行为，更是一种享受生活的方式！",
      "把握机会，购买你心仪的产品，让生活更加丰富多彩！",
      "购买是一次奇妙的冒险，让我们一起踏上这段旅程！",
      "点击购买，为自己带来一份惊喜和幸福！",
      "购买是一种表达，让我们一起用心选择！",
    ],
  },
};
